import { render } from "./CompareOverlay.vue?vue&type=template&id=a5bfea38&scoped=true"
import script from "./CompareOverlay.vue?vue&type=script&lang=js"
export * from "./CompareOverlay.vue?vue&type=script&lang=js"

import "./CompareOverlay.vue?vue&type=style&index=0&id=a5bfea38&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5bfea38"]])

export default __exports__